import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { PlainRoute } from 'react-router';
import { StoreState } from '../../reducers';
import { setRouteParams } from './actions';

interface SetRouteParamsProps {
	params: {};
	routes: PlainRoute[];
	setRouteParams: (data: {}, routes: PlainRoute[]) => Dispatch<StoreState>;
	dispatch: Dispatch<StoreState>;
}

export default (Component: React.ComponentClass<{} | SetRouteParamsProps>) => {

	class SetRouteParams extends React.Component<SetRouteParamsProps, {}> {

		componentWillMount() {
			this.props.setRouteParams(this.props.params, this.props.routes);
		}

		componentWillUpdate(nextProps: SetRouteParamsProps) {
			this.props.setRouteParams(nextProps.params, nextProps.routes);
		}

		render() {
			return <Component {...this.props} />;
		}
	}

	return connect(null, { setRouteParams })(SetRouteParams);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SetRouteParams/index.tsx